/**
 * Health Dashboard Utility Functions
 * Optimized for performance with proper memoization
 */

// Store Icon
export const StoreIcon = ({ size = 24, color = "#ef4444" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6H20L21 10H3L4 6Z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />

    <rect
      x="4"
      y="10"
      width="16"
      height="10"
      stroke={color}
      strokeWidth="2"
      rx="1"
    />

    <path
      d="M9 20V15C9 13.9 9.9 13 11 13H13C14.1 13 15 13.9 15 15V20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M7 10V8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 10V8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M17 10V8"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Warning Icon
export const WarningIcon = ({ size = 24, color = "#f5b301" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L21 20H3L12 4Z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 9V14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="12" cy="17" r="1" fill={color} />
  </svg>
);

// Trend Icon
export const TrendIcon = ({ size = 24, color = "#6b7280" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 16L8 11L12 13L17 7L21 9"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Globe Icon
export const GlobeIcon = ({ size = 24, color = "#6b7280" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={color}
      strokeWidth="2"
    />

    <path
      d="M3 12H21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M12 3C14.5 5.5 16 8.7 16 12C16 15.3 14.5 18.5 12 21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M12 3C9.5 5.5 8 8.7 8 12C8 15.3 9.5 18.5 12 21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);


// Heart Icon
export const HeartIcon = ({ size = 24, color = "#6BAF6E" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21C12 21 4 15.5 4 9.5C4 6.5 6.2 4.5 9 4.5C10.8 4.5 12 5.6 12.8 6.8C13.6 5.6 14.8 4.5 16.6 4.5C19.4 4.5 21.6 6.5 21.6 9.5C21.6 15.5 12 21 12 21Z"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Alert Bell Icon
export const AlertBellIcon = ({ size = 24, color = "#ef4444" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C9.8 4 8 5.8 8 8V11.5L6 15H18L16 11.5V8C16 5.8 14.2 4 12 4Z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />

    <path
      d="M10 18C10.4 19.2 11 20 12 20C13 20 13.6 19.2 14 18"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />

    <path
      d="M12 2V4"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// Health Operations Icon
export const HealthOperationsIcon = ({ size = 24, color = "#1F2937" }) => (
  <svg
   width={size} height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12H7L9 6L13 18L15.5 10H22"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// Constants
export const HEALTH_LIMITS = {
  RED_MAX: 80,
  AMBER_MAX: 99,
};

export const HEALTH_TABS = {
  HEALTH: "health",
  AI: "ai",
};

export const HEALTH_UI = {
  TITLE: "Service Health",
  FILTER_ON_SERVICE: "Unhealthy",
  FILTER_DEFAULT: "All",
  LOADING: "Loading...",
};

export const SERVICE_TO_ISSUE_MAP = {
  "Digital Ordering": "DigitalOrdering",
  "My Store": "MyStore",
  Sesame: "Sesame",
  ePROD: "eProd",
};

// Entity GUIDs by Account
export const ENTITY_GUIDS_BY_ACCOUNT = {
  default: {
    DigitalOrdering: "MzU5MjU1NnxWSVp8REFTSEJPQVJEfGRhOjEyMjY0OTYw",
    Sesame: "MzU5MjU1NnxWSVp8REFTSEJPQVJEfGRhOjEyMjEyOTc2",
    eProd: "vvvv",
    MyStore: "MzU5MjU1NnxWSVp8REFTSEJPQVJEfGRhOjEyMjEyOTc5",
  },
  "4091918": {
    Sesame: "NDA5MTkxOHxWSVp8REFTSEJPQVJEfGRhOjEyMjEyODUw",
    DigitalOrdering: "NDA5MTkxOHxWSVp8REFTSEJPQVJEfGRhOjEyMjEyOTUy",
    eProd: "vvvv",
    MyStore: "NDA5MTkxOHxWSVp8REFTSEJPQVJEfGRhOjEyMjEyODcz",
  },
};

/**
 * Convert service data to card array
 */
export function toCards(dataObj) {
  if (!dataObj || typeof dataObj !== "object") return [];
  return Object.entries(dataObj)
    .filter(
      ([key, value]) =>
        !["timestamp", "x", "y"].includes(key) && typeof value === "number"
    )
    .map(([key, value], idx) => ({
      id: idx + 1,
      label: key,
      percentage: Number(value) || 0,
    }))
    .sort((a, b) => a.label.localeCompare(b.label)); // Stable sort
}

/**
 * Determine if color indicates impacted status
 */
export function isImpactedColor(color) {
  if (!color) return false;
  const c = String(color).toLowerCase();
  return c === "red" || c === "amber" || c === "#ffc107";
}

/**
 * Get gauge color based on value
 */
export function getGaugeColor(val) {
  const v = Math.max(0, Math.min(100, Number(val) || 0));
  if (v < HEALTH_LIMITS.RED_MAX) return "oh-red";
  if (v <= HEALTH_LIMITS.AMBER_MAX) return "oh-yellow";
  return "oh-green";
}

/**
 * Resolve issue name for service
 */
export function resolveIssueForService(serviceLabel) {
  return SERVICE_TO_ISSUE_MAP[serviceLabel] ?? serviceLabel;
}

/**
 * Get services with issues from stores data
 */
export function getServiceIssues(storesData, serviceName) {
  if (!Array.isArray(storesData) || !serviceName) return [];

  return storesData.filter((row) => {
    return (
      (row?.color === "red" || row?.color === "amber") &&
      (row?.status === "down" || row?.status === "degraded") &&
      String(row?.issue ?? "").trim() === serviceName
    );
  });
}

/**
 * Group detail information by alert
 * Optimized: uses reduce with proper guards
 */
export function getDetailGroups(input = []) {
  const data = Array.isArray(input) ? input : [];
  return data
    .filter((item) => item?.alert && String(item.alert).trim() !== "")
    .reduce((acc, item) => {
      const key = item.alert || "(no detail)";

      if (!acc[key]) {
        acc[key] = { alert: key, count: 0, stores: [] };
      }
      acc[key].count++;
      acc[key].stores.push(item);
      return acc;
    }, {});
}

/**
 * Group only red + down stores by issue
 * Optimized with early returns and strict checks
 */
export function getIssueWiseDownStores(storesData) {
  if (!Array.isArray(storesData) || storesData.length === 0) return {};

  const output = {};

  for (const row of storesData) {
    if (row?.color === "red" && row?.status === "down" && row?.alert) {
      const alert = String(row.alert).trim();
      const detailName = String(row.detail ?? "Unknown Detail").trim();
      const groupKey = alert;

      if (!output[groupKey]) {
        output[groupKey] = {
          alert,
          detail: detailName,
          count: 0,
          stores: [],
          issue: alert,
        };
      }
      output[groupKey].count += 1;
      output[groupKey].stores.push({
        store: row.store,
        alert,
        detail: detailName,
        issue: alert,
      });
    }
  }

  return output;
}

/**
 * Calculate impacted stores count
 */
export function calculateImpactedStores(storesData = []) {
  return storesData.reduce(
    (acc, s) => acc + (isImpactedColor(s?.color) ? 1 : 0),
    0
  );
}

/**
 * Calculate total unique stores
 */
export function calculateTotalStores(storesData = [], stores = []) {
  const ids = new Set();
  for (const s of storesData || []) {
    if (s?.store != null) ids.add(String(s.store));
  }
  for (const s of stores || []) {
    if (s?.store != null) ids.add(String(s.store));
  }
  return ids.size;
}

/**
 * Clean alert detail
 */
export function cleanDetail(alert, detail) {
  if (!alert || !detail) return detail;
  let cleaned = detail.replace(alert, "").trim();
  return cleaned;
}

/**
 * Generate entity GUID
 */
export function generateEntityGuid(accountId, serviceName, storeId) {
  const raw = `${accountId}|EXT|${serviceName}|${storeId}`;
  return btoa(raw).replaceAll("=", "");
}

/**
 * Get GUID map for account
 */
export function getGuidMapForAccount(accountId) {
  return (
    ENTITY_GUIDS_BY_ACCOUNT[String(accountId)] ||
    ENTITY_GUIDS_BY_ACCOUNT.default
  );
}
